module.exports = function (getRestrictions, value) {
  var restrictions = getRestrictions('currencies');

  if (restrictions.length) {
    var v = value.match(/[\d+|\\.|\\,]/g);
    var errorMessages = [];
    if (!v) {
      throw {
        message: 'currency_format',
        params: _.extend({ value: value }, restrictions[0])
      };
    }

    v = parseFloat(v.join(''));
    var accepted = '\\d+|\\s+|\\.|\\,' + _.map(restrictions, function (r) {
      return r.currency;
    }).join('|');

    for (var i in restrictions) {
      var params = _.extend({ value: value }, restrictions[i]);
      var itOutOfRange = (_.isNumber(restrictions[i].max) && restrictions[i].max < v)
        || (_.isNumber(restrictions[i].min) && restrictions[i].min > v);

      if (value.indexOf(restrictions[i].currency) < 0) {
        errorMessages.push({ message: 'currency_format', params: params });
      }

      if (itOutOfRange) {
        errorMessages.push({ message: 'currency_range', params: params });
      }
    }

    if (errorMessages.length) {
      throw errorMessages;
    }

    value = value.match(new RegExp('[' + accepted + ']', 'g')).join('').replace(/\s+/, ' ');
  }

  return value;
};
